export default __webpack_public_path__ + "static/media/red_audio.6f6e2e23.mp3";